import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';

import { getProductIds } from '@features/crm/utils/helpers';
import EODate from '@features/collection/components/EODate';

import { storeCRMProducts } from '@store/actions/crm/CRMCommonAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addSalesFunnelEOD } from '@services/crmService';

import { renderSetImages, STATIC_SET_CONSTANTS } from '@utils/Util';

const EODModal = ({ showEDDModal, setShowEDDModal, onClearSelectedProducts, fetchSalesFunnelTableData }) => {
	const dispatch = useDispatch();

	const selectedCRMProducts = useSelector((state) => state.crmCommonStore.selectedCRMProducts);
	const isLoading = useSelector((store) => store.loaderStore);

	const [isEoDateError, setIsEoDateError] = useState(false);
	const [eoDate, setEoDate] = useState(null);

	const onSubmit = async () => {
		const postData = {
			expectedOrderDate: eoDate,
			idList: getProductIds(selectedCRMProducts)
		};
		try {
			dispatch(openLoader());
			await addSalesFunnelEOD(postData);
			await fetchSalesFunnelTableData(0);
			await dispatch(storeCRMProducts([]));
		} finally {
			setShowEDDModal(false);
			dispatch(closeLoader());
			onClearSelectedProducts();
		}
	};

	const onCancelPopUp = () => {
		setShowEDDModal(false);
	};

	return (
		<Modal
			show={showEDDModal}
			onHide={onCancelPopUp}
			backdrop="static"
			className="width-720-modal eod-details-modal"
			centered
		>
			<div className="common-popup eod-details-popup shadow-24dp">
				<div className="common-popup-header border-0 d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Expected Order Date (EOD)</h3>
					</div>

					<div className="close-btn" onClick={onCancelPopUp}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<Modal.Body>
					<div className="common-popup-body pb-0 scroll-y-label">
						<div className="selected-styles p-3">
							<div className="selected-date">
								<EODate
									eoDate={eoDate}
									setEoDate={(val) => {
										setIsEoDateError(false);
										setEoDate(val);
									}}
									isEoDateError={isEoDateError}
								/>
							</div>
							<div className="eod-all-item">
								<p className="semibold-14 gray_dark_02 mb-12 pt-3">Selected Styles</p>
								<div className="eod-item">
									{selectedCRMProducts?.map((product, idx) => (
										<div
											className="eod-single d-flex align-items-center radius-4"
											key={`crm_product_${idx}`}
										>
											<div className="img">
												{product?.setPackStyleFlag ===
													STATIC_SET_CONSTANTS.SET_PRODUCT &&
													renderSetImages(
														product?.featureImageUrl?.map((item) => ({
															docUrl: item
														}))
													)}
												{product?.setPackStyleFlag !==
													STATIC_SET_CONSTANTS.SET_PRODUCT && (
													<img
														src={product?.featureImageUrl?.[0]}
														alt="style"
														className="cell-img"
													/>
												)}
											</div>
											<div className="content ml-3">
												{product?.setPackStyleFlag ===
													STATIC_SET_CONSTANTS.SET_PRODUCT && (
													<>
														<span className="status text-white">set</span>
														<p className="regular-12 gray_dark_01 weight-500">
															{product.productReferenceNumber}
														</p>
														<ul className="common-list-component">
															<li>
																<span>
																	{
																		product?.setMemberProducts?.[0]
																			.productGroupName
																	}
																</span>
															</li>
															{product?.setMemberProducts?.map((product) => (
																<li key={product.id}>
																	<span>{product.categoryName}</span>
																</li>
															))}
														</ul>
													</>
												)}
												{product?.setPackStyleFlag !==
													STATIC_SET_CONSTANTS.SET_PRODUCT && (
													<>
														<p className="regular-12 gray_dark_01 weight-500">
															{product.productReferenceNumber}
														</p>
														<ul className="common-list-component">
															<li>
																<span>{product.productGroupName}</span>
															</li>
															<li>
																<span>{product.categoryName}</span>
															</li>
														</ul>
													</>
												)}
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onCancelPopUp}>
							<span className="gray_dark_02">Cancel</span>
						</button>
						<button
							className="button size32 ml-2"
							onClick={() => {
								onSubmit();
							}}
							disabled={isLoading || eoDate === null}
						>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default EODModal;
